// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1148c37d","239":"cfb2871c","667":"14a91684"}[chunkId] + ".chunk.js";
};